import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { Postdata } from "../../helpers/api.service";
import HttpService from "../../helpers/httpServices";
import Loader from "../common/Loader";
import dayjs from "dayjs";
import HiOutlineDotsVertical from "../../assets/Icons/HiOutlineDotsVertical.svg";
import DeleteModal from "../common/DeleteModal";
import { isPermission, isRole, isRoleType } from "../../redux/selectors/authSelector";
import Error403Page from "../../pages/ErrorPage";
import { toast } from "sonner";
import { useCountryNavigate } from "../common/UseCountryNavigate";

const Arts = () => {
  const [modalOpenDelete, setmodalOpenDelete] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [openMenuIndex, setOpenMenuIndex] = useState(null);
  const [data, setData] = useState([]);
  // const navigate = useNavigate();
  const navigate = useCountryNavigate();
  const menuRefs = useRef([]);
  const dispatch = useDispatch();
  const [refresh, setRefresh] = useState(false);
  const [loader, setLoader] = useState(false);
  const [modalOpenDeleteSuccess, setModalOpenDeleteSuccess] = useState(false);
  const permissions = useSelector(isPermission);
  const role = useSelector(isRole);
  const role_type = useSelector(isRoleType);

  const mode = localStorage.getItem("mode");
  console.log("permissions", permissions);
  const location = useLocation();
  const isAccessible =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("view_Extracurricular") || permissions?.includes("view_School"))) ||
    false;
  const addPermission =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("edit_Extracurricular") || permissions?.includes("edit_School"))) ||
    false;
  const deletePermission =
    role == "admin" ||
    role == "subadmin" ||
    role == "schooladmin" ||
    (permissions && (permissions?.includes("delete_Extracurricular") || permissions?.includes("delete_School"))) ||
    false;
  const schoolId = localStorage.getItem("activeSchoolId");

  const toggleMenu = (index) => {
    setOpenMenuIndex(openMenuIndex === index ? null : index);
  };

  const handleDelete = (id) => {
    setLoader(true);
    Postdata(HttpService.arts_delete, { id: id, school_id: schoolId }).then(
      (res) => {
        if (res.status === 200) {
          toast.success("Arts deleted successfully");
          setRefresh(!refresh);
        }
        // else {
        //     dispatch(message(res.message));
        // }
        setLoader(false);
      }
    );
    setOpenMenuIndex(null);
  };

  const fetchData = () => {
    setLoader(true);
    Postdata(HttpService.arts_list, { school_id: schoolId }).then((res) => {
      if (res.status === 200) {
        setData(res.data);
      }
      // else {

      //     dispatch(message(res.message));
      // }
      setLoader(false);
    });
  };
  useEffect(() => {
    fetchData();
  }, [refresh]);

  // Close menu on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      let clickedInside = false;
      menuRefs.current.forEach((ref) => {
        if (ref && ref.contains(event.target)) {
          clickedInside = true;
        }
      });
      if (!clickedInside) {
        setOpenMenuIndex(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  useEffect(() => {
    // Navigate to /settings with currentTab only once
    if (location?.state?.currentTab !== "Arts") {
      // navigate("/extracurricular", {
      //     replace: true,
      //     state: { currentTab: "Arts" },
      // });
    }
  }, []);

  if (loader) {
    return <Loader isClass="loader_fullscreen" />;
  }

  if (!isAccessible) {
    return <Error403Page />;
  }
  return (
    <div className="p-6 space-y-6 pr-0">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
        {data.length > 0 &&
          data.map((item, index) => (
            <div className="bg-white rounded-lg " key={index}>
              <img
                className="w-full h-60 object-cover  mb-2"
                src={item.image}
                onClick={() =>
                  navigate(`extracurricular/arts/view/${item._id}`)
                }
              />
              <div className=" relative flex justify-between text-gray-800   mx-auto">
                <div className="w-full px-3">
                  {" "}
                  {/* full width container */}
                  <h3 className="text-sm font-semibold pt-2 break-words whitespace-normal">
                    {item.title}
                  </h3>
                  <h3 className="text-sm font-normal mt-1 break-words whitespace-normal">
                    {item.brief}
                  </h3>
                  <h3 className="text-sm text-gray-400 font-normal mt-1">
                    {dayjs(item.createdAt).format("DD MMM YYYY")}
                  </h3>
                </div>
                {(addPermission || deletePermission) && (
                  <div className="bg-white ">
                    <div className="absolute top-3 right-3">
                      <button onClick={() => toggleMenu(index)}>
                        <img
                          src={HiOutlineDotsVertical}
                          className="text-black-500 hover:text-black"
                        />
                      </button>

                      {openMenuIndex == index && (
                        <div
                          ref={(el) => (menuRefs.current[index] = el)}
                          className="absolute right-5 bottom-0 w-20 bg-white shadow-md border rounded-xl z-10"
                        >
                          {addPermission && (
                            <button
                              className="block w-full text-left px-3 rounded-t-xl py-2 text-sm hover:bg-gray-100"
                              onClick={() =>
                                navigate(
                                  `extracurricular/arts/edit/${item._id}`,
                                  { state: { type: "edit" } }
                                )
                              }
                            >
                              Edit
                            </button>
                          )}
                          {deletePermission && (
                            <button
                              onClick={() => {
                                setSelectedId(item._id);
                                setmodalOpenDelete(true);
                              }}
                              className="block w-full text-left px-3 rounded-b-xl py-2 text-sm hover:bg-gray-100"
                            >
                              Delete
                            </button>
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        <DeleteModal
          title="Delete Arts"
          message="Are you sure you want to delete Arts?
It will erase all the data permanently."
          modalOpenDelete={modalOpenDelete}
          setmodalOpenDelete={setmodalOpenDelete}
          handleDelete={handleDelete} // Don't call it here
          selectedId={selectedId}
          setSelectedId={setSelectedId}
          modalOpenDeleteSuccess={modalOpenDeleteSuccess}
          setModalOpenDeleteSuccess={setModalOpenDeleteSuccess}
          module={"Arts"}
          redirectPage={"Extracurricular"}
          // redirectUrl={'/extracurricular'}
          redirectUrl={
            mode === "view"
              ? `admin-school/view/${schoolId}`
              : role === "admin" || role === "subadmin" || role_type === "schoolsubadmin" || role_type === "subadmin"
                ? "navigation-dashboard"
                : "extracurricular"
          }
        />
      </div>
      {data.length === 0 && (
        <div className="h-[50vh] flex items-center justify-center w-full">
          <h1 className="text-center text-gray-400">No Data Found</h1>
        </div>
      )}
    </div>
  );
};

export default Arts;
